module.exports = __webpack_public_path__ + "img/202411_04.4f3e9af6.jpg";